import React, { useState } from 'react';
import { getI18n } from 'react-i18next';

import { Button, Cascader } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { FiEdit } from 'react-icons/fi';
import { withRouter } from 'react-router';
import ConfirmationModal from '../../../elements/components/ConfirmationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBan, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const confirmTexts = {
  title: getI18n().t('cognito_forms_admin_action_delete_title'),
  description: null,
  leaveText: getI18n().t('cognito_forms_admin_action_delete_leave'),
  saveText: getI18n().t('cognito_forms_admin_action_delete_save'),
};

const ListAction = ({
  row,
  partnershipId,
  history,
  handleDisabled,
  handleDelete,
  page,
  limit,
  order,
  filter,
  showForm,
  trackerActions,
  ...props
}) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationModalDisabledOpen, setConfirmationModalDisabledOpen] =
    useState(false);

  const { id, public_status } = row;

  const confirmTextsDisabled = {
    title:
      public_status === 1
        ? getI18n().t('cognito_forms_admin_action_disabled_title')
        : getI18n().t('cognito_forms_admin_action_enabled_title'),
    description: null,
    leaveText:
      public_status === 1
        ? getI18n().t('cognito_forms_admin_action_disable_leave')
        : getI18n().t('cognito_forms_admin_action_enable_leave'),
    saveText: getI18n().t('cognito_forms_admin_action_disabled_save'),
  };

  const menuItems = [
    {
      label: (
        <span className='cognito-form-table-menu-item'>
          <FiEdit />
          <span className='text-align'>
            {getI18n().t('cognito_forms_admin_action_edit')}
          </span>
        </span>
      ),
      value: 1,
    },
    {
      label: (
        <span className='cognito-form-table-menu-item'>
          {public_status === 1 ? (
            <FontAwesomeIcon icon={faBan} size='2x' />
          ) : (
            <FontAwesomeIcon icon={faCheck} size='2x' />
          )}
          <span className='text-align'>
            {public_status === 1
              ? getI18n().t('cognito_forms_admin_action_disabled')
              : getI18n().t('cognito_forms_admin_action_enabled')}
          </span>
        </span>
      ),
      value: 2,
    },
    {
      label: (
        <span
          className='cognito-form-table-menu-item'
          style={{ color: '#F44336' }}
        >
          <FontAwesomeIcon icon={faTrashCan} size='2x' />
          <span className='text-align'>
            {getI18n().t('cognito_forms_admin_action_delete')}
          </span>
        </span>
      ),
      value: 3,
    },
  ];

  const onChange = (item) => {
    const value = item[0];

    if (value === 1) {
      showForm(row.id);
      trackerActions(
        mixpanelEventsEnum.ACTIONS_PARTNER.COGNITO_FORMS_ADMIN_EDIT_SCREEN
      );
    } else if (value === 2) {
      setConfirmationModalDisabledOpen(true);
    } else if (value === 3) {
      setConfirmationModalOpen(true);
    }
  };

  const handleConfirmLeave = () => {
    setConfirmationModalOpen(false);
  };

  const handleConfirmDelete = () => {
    setConfirmationModalOpen(false);
    handleDelete(id);
  };

  const handleConfirmLeaveDisabled = () => {
    setConfirmationModalDisabledOpen(false);
  };

  const handleConfirmDisabled = () => {
    handleDisabled(id, public_status === 1 ? 2 : 1, page, limit, order, filter);
    setConfirmationModalDisabledOpen(false);
  };

  return (
    <span onClick={(e) => e.stopPropagation()} className='actions'>
      <Cascader
        options={menuItems}
        onChange={onChange}
        dropdownMenuColumnStyle={{ height: '32px' }}
        defaultValue={[]}
        value={[]}
      >
        <Button
          style={{ verticalAlign: '2px' }}
          icon={<EllipsisOutlined />}
          type='text'
          onClick={(e) => e.stopPropagation()}
        ></Button>
      </Cascader>
      <ConfirmationModal
        texts={confirmTexts}
        openConfirmationModal={confirmationModalOpen}
        onLeaveConfirmation={handleConfirmDelete}
        onSaveConfirmation={handleConfirmLeave}
        onCancel={handleConfirmLeave}
        setConfirmationModalOpen={setConfirmationModalOpen}
      />
      <ConfirmationModal
        texts={confirmTextsDisabled}
        openConfirmationModal={confirmationModalDisabledOpen}
        onLeaveConfirmation={handleConfirmDisabled}
        onSaveConfirmation={handleConfirmLeaveDisabled}
        onCancel={handleConfirmLeaveDisabled}
        setConfirmationModalOpen={setConfirmationModalDisabledOpen}
      />
    </span>
  );
};

export default withRouter(ListAction);
